import React from 'react';

const Footer = () => {
  return (
    <footer className="py-8 px-6 border-t border-zinc-900 bg-black text-center md:text-left">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center text-zinc-600 text-sm">
        <p>© 2024 MANIFEST1223. All rights reserved.</p>
        <div className="flex gap-6 mt-4 md:mt-0">
          <span className="hover:text-white cursor-pointer transition-colors">Privacy Policy</span>
          <span className="hover:text-white cursor-pointer transition-colors">Terms of Service</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
